export type ColorPalette = Color[];

export type ColorMap = { [valueKey: string]: string };

export type MapOfColorMaps = { [valueKey: string]: ColorMap };

export class Color {

    static createFromString(s: string): Color {
        const [r, g, b, a] = Color.parseColor(s);
        return new Color(r, g, b, a);
    }

    private static parseColor = (color: string): [number, number, number, number] => {
        let result;

        // Check if the color is in hex format
        if (color.startsWith('#')) {
            // Remove the hash sign if it's included
            color = color.replace(/^#/, '');

            // Check if the color is in short hex format (3 or 4 digits)
            if (color.length === 3 || color.length === 4) {
                color = color.split('').map(char => char + char).join('');
            }
            if (color.length === 6) {
                color = color + "ff";
            }

            // Parse the hex values
            const bigint = parseInt(color, 16);
            const r = (bigint >> 24) & 255;
            const g = (bigint >> 16) & 255;
            const b = (bigint >> 8) & 255;
            const a = (bigint & 255) / 255;

            result = [ r, g, b, color.length === 8 ? a : 1 ];
        } else if (color.startsWith('rgb')) {
            // Check if the color is in rgb or rgba format
            const values = color.match(/(\d+(\.\d+)?)/g).map(Number);
            result = [values[0], values[1], values[2], values.length === 4 ? values[3] : 1]
        } else {
            throw new Error('Unsupported color format');
        }

        return result;
    }

    private r: number = 0;
    private g: number = 0;
    private b: number = 0;
    private a: number = 1;


    constructor(r: number, g: number, b: number, a: number = 1) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }

    public getRed = (): number => this.r;

    public getGreen = (): number => this.g;

    public getBlue = (): number => this.b;

    public getAlpha = (): number => this.a;

    public toHex = (useAlpha: boolean = false) => {
        const toHex = (n) => n.toString(16).padStart(2, '0');
        const alpha = Math.round(this.a * 255);
        return `#${toHex(this.r)}${toHex(this.g)}${toHex(this.b)}${useAlpha ? toHex(alpha) : ""}`;
    }

    public toCssRGB = () => {
        return `rgba(${this.r}, ${this.g}, ${this.b})`;
    }

    public toCssRGBA = () => {
        return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    }

    public toTriple = (): [number, number, number] => {
        return [this.r, this.g, this.b];
    }

}